import { render, staticRenderFns } from "./ComplaintDownloadList.vue?vue&type=template&id=618ce182"
import script from "./ComplaintDownloadList.vue?vue&type=script&lang=js"
export * from "./ComplaintDownloadList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDownloadList.vue?vue&type=style&index=0&id=618ce182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports